export default function responsiveBaseSizes() {
    // mobile base size
    document.documentElement.style.setProperty('--mobile-base-size', (window.innerWidth / 320).toString());

    // tablet base size
    document.documentElement.style.setProperty('--tablet-base-size', (window.innerWidth / 1024).toString());

    window.addEventListener('resize', () => {
        document.documentElement.style.setProperty('--mobile-base-size', (window.innerWidth / 320).toString());
        document.documentElement.style.setProperty('--tablet-base-size', (window.innerWidth / 1024).toString());
    });
}
